import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { CostCenterFilterOptionsModel } from '../../models/cost-center/cost-center-filter-options.model';
import { TableColumn } from '../../models/table-column';
import {
  getCostCenterFilterOptions,
  getTableColumns,
} from './cost-center-table-columns';

export interface CostCenterListState {
  columns: TableColumn[];
  filterOptions: CostCenterFilterOptionsModel;
  filterValue: string;
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'cost-center-list' })
export class CostCenterListStore extends Store<CostCenterListState> {
  constructor() {
    super({
      columns: getTableColumns(),
      filterOptions: getCostCenterFilterOptions(),
      filterValue: '',
    });
  }
}
